/**
 * Bazowa klasa (Base Entity) dla obiektów domenowych w systemie.
 * Zapewnia wspólny interfejs dla modeli, wymuszając obecność unikalnego identyfikatora.
 */
export class GenericObject {

  /**
   * Globalnie unikalny identyfikator obiektu.
   */
  public uuid: string;

}
